<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      積替運搬詳細
    </h2>
    <order-request-form />
  </v-container>
</template>
<script>
import OrderRequestForm from './_Form'

export default {
  name: 'OrderRequestCollectionShow',
  components: {
    OrderRequestForm
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '発注（積替・搬入）', disabled: false, to: '/driver/orders/requests', exact: true },
        { text: '積替運搬詳細', disabled: true, to: '' },
      ]
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>
